module.exports = __webpack_public_path__ + "ki.svg?6e36c68267a6c21961e520ccadd3f21c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ki.svg
// module id = 1044
// module chunks = 27